import { RouteObject } from 'react-router'
import { InvitationAcceptPage } from '../pages/accept'
import { InvitationVerifyPage } from '../pages/verify'
import { RequiresVerification } from '../components/guards/requires-verification'
import { InvitationCodePage } from '../pages/code'
import { InvitationProvider } from '../components/invitation-provider'

export enum InvitationRoutePath {
  InvitationsVerify = '/invitations/:token/verify',
  InvitationsCode = '/invitations/:token/code',
  InvitationsAccept = '/invitations/:token',
}

export const publicInvitationRoutes: RouteObject[] = [
  {
    path: InvitationRoutePath.InvitationsAccept,
    element: (
      <InvitationProvider>
        <RequiresVerification>
          <InvitationAcceptPage />
        </RequiresVerification>
      </InvitationProvider>
    ),
  },
  {
    path: InvitationRoutePath.InvitationsVerify,
    element: (
      <InvitationProvider>
        <InvitationVerifyPage />,
      </InvitationProvider>
    ),
  },
  {
    path: InvitationRoutePath.InvitationsCode,
    element: (
      <InvitationProvider>
        <InvitationCodePage />
      </InvitationProvider>
    ),
  },
]
